const Blank = ({ children }) => {
    return children;
}

export default Blank;
